module.exports = __webpack_public_path__ + "Frame416-7c94ab5c.webp";